import { LinearProgress, SelectChangeEvent } from "@mui/material";
import { FormLookupsContext, GroupedField, InstitutionContext, Select } from "@ngt/opms";
import { FC, ReactNode, useContext, useMemo } from "react";
import usePersonnelLookup from "../../../hooks/lookups/usePersonnelLookup";


export interface IRadiologistSelectorProps {
    dialog?: boolean,
    disabled?: boolean,
    propertyPath?: string,
    onChange?: (event: SelectChangeEvent<any>, child: ReactNode, selectedItem: any) => void
}

const RadiologistSelector: FC<IRadiologistSelectorProps> = ({
    dialog,
    disabled,
    propertyPath,
    onChange
}) => {
    
    const { data: institution } = useContext(InstitutionContext);

    const { data: radiologistLookup, loading } = usePersonnelLookup(propertyPath ?? "radiologist", [56], institution?.code);

    const radiologists = useMemo(() => [radiologistLookup], [radiologistLookup])

    return (
        <FormLookupsContext.Provider value={radiologists}>
            {
                loading ? 
                    <LinearProgress color='primary' /> : 
                    <GroupedField 
                        propertyPath={propertyPath ?? "radiologist"}
                        label={dialog === true ? "Radiologist" : undefined}
                        component={Select}
                        onChange={onChange}
                        FieldGridProps={{
                            size: {
                                xl: dialog ? 12 : undefined,
                                lg: dialog ? 12 : undefined,
                                md: dialog ? 12 : undefined,
                                sm: dialog ? 12 : undefined,
                                xs: dialog ? 12 : undefined
                            }
                        }}
                        disabled={disabled}
                        fullWidth
                    />
            }    
        </FormLookupsContext.Provider>
    );
}

export default RadiologistSelector;